/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'
import BackupIcon from '@mui/icons-material/Backup'
import DownloadingOutlined from '@mui/icons-material/DownloadingOutlined'
import ViewAgenda from '@mui/icons-material/ViewAgenda'
import HelpIcon from '@mui/icons-material/Announcement'
import { withEnv } from '@praxis/component-runtime-env'
import { withAuth } from '@praxis/component-auth'
import { useTheme, makeStyles } from '@mui/styles'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Toolbar from '@mui/material/Toolbar'
import AppBar from '@mui/material/AppBar'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import Divider from '@mui/material/Divider'
import {
  selectUserEmail,
  selectIsAuthorized,
  selectUserId,
  selectMemberOf,
  selectUserCompany,
} from '../../store/auth/selector'
import { toggleUploadManager } from '../../store/uploads/actionCreator'
import { toggleRightSidenav } from '../../store/layout/actionCreator'
import {
  selectHeaderSubtitle,
  selectIsToggleRightSidenav,
  selectRightSideNavComponent,
} from '../../store/layout/selector'
import { praxis } from '../../config/themeConfig'
import { appBarStyles } from '../SecondaryNav'
import { BOARDS_TITLE, DOWNLOAD_MANAGER } from '../../constants/search'
import withRouter from '../../containers/Router/WithRouter'
import Feedback from '../Feedback/Feedback'
import Dropdown from './Dropdown'

const styles = makeStyles((theme) => ({
  header: {
    height: 50,
    [`${useTheme().breakpoints.up('xs')} and (orientation: landscape)`]: {
      height: 48,
    },
    [useTheme().breakpoints.up('sm')]: {
      height: 50,
    },
  },
  appBar: {
    ...appBarStyles,
    zIndex: 1,
    position: 'relative',
    paddingLeft: '15px',
    backgroundColor: 'white!important',
    boxShadow: '0px 2px 6px #0000000F',
  },
  toolbar: {
    minHeight: '64px !important',
    alignItems: 'center',
  },
  toolbarWithSubtitle: {
    minHeight: '78px !important',
    alignItems: 'center',
    paddingTop: 8,
    paddingBottom: 8,
  },
  appBarHelp: {
    ...appBarStyles,
    zIndex: 9,
    position: 'relative',
    paddingLeft: '15px',
    backgroundColor: 'white!important',
    boxShadow: '0px 2px 6px #0000000F',
  },
  button: {
    color: useTheme().palette.primary.contrastText,
  },
  headerBlock: {
    minHeight: 64,
    fontSize: 13,
    marginLeft: 50,
  },
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  flex: {
    flex: 1,
    minWidth: 0,
    margin: '0 !important',
  },
  titleBlock: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: 0,
  },
  titleText: {
    fontSize: '20px',
    color: praxis.themePrimary,
    '&:focus, &:hover, &:visited, &:link, &:active': {
      textDecoration: 'none !important',
    },
    margin: '0 !important',
    lineHeight: 1.2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  subtitleText: {
    marginTop: 2,
    color: '#5F6368',
    fontSize: '12px',
    lineHeight: 1.35,
    whiteSpace: 'normal',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    maxWidth: '100%',
  },
  menuButton: {
    marginLeft: -12,
  },
  uploadManagerActive: {
    backgroundColor: '#43425D',
    padding: '20px 16px',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#43425D !important',
    },
  },
  navButtonActive: {
    backgroundColor: useTheme().palette.primary.themePrimary,
    padding: '20px 16px',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: useTheme().palette.primary.themePrimary + ' !important',
    },
  },
  uploadManager: {
    padding: '20px 16px',
    borderRadius: 0,
  },
  headerIcon: {
    color: '#BCBCCB',
    height: '22px',
  },
  divider: {
    marginTop: '15px',
    marginBottom: '15px',
    marginRight: '10px',
  },
  buttonGroup: {
    position: 'relative',
    color: '#3D70D6',
    borderBottom: '1px solid #D3D5D8',
    width: '98%',
    padding: ' 0 0 0 6.5rem',
  },
  referenceStyleButton: {
    marginLeft: '100px',
    color: '#178295',
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },
}))

export const Header = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const classes = styles()

  useEffect(() => {
    const breadCrumb = document.getElementById('breadCrumb')
    if (breadCrumb) {
      Array.from(breadCrumb.querySelectorAll('a[href]')).forEach((node) => {
        node.addEventListener('click', (e) => {
          e.preventDefault()
          props.router?.navigate(e.target.getAttribute('href'))
        })
      })
    }
  }, [props.router])


  const addFeedback = () => {
    setIsModalOpen(true)
  }

  const onClose = () => {
    setIsModalOpen(false)
  }

  const toggleUploadManager = () => {
    props.toggleUploadManager()
  }

  const {
    title,
    subtitle,
    showFeedBack,
    uploads = {},
    isToggleRightSidenav,
    rightSideNavComponent,
    toggleRightSidenav = () => { },
    user,
    env = {},
    auth = {},
  } = props
  const { REACT_APP_ROLES_CONFIG = {}, FEATURE_CONFIG = {} } = env
  const { ENABLE_ZIP_DOWNLOADS = false } =  FEATURE_CONFIG
  const { showUploadManager = false } = uploads
  const { company = '', displayName = '' } = user
  const { projects = [], boards = [], search = [] } = REACT_APP_ROLES_CONFIG

  const isAuthorized = auth?.isAuthorized || (() => false)
  const hasSubtitle = Boolean(subtitle)

  return (
    <div style={{ height: hasSubtitle ? '78px' : '64px' }}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar
          className={
            hasSubtitle ? classes.toolbarWithSubtitle : classes.toolbar
          }
        >
          <Typography
            variant="subtitle1"
            id="breadCrumb"
            color="inherit"
            className={classes.flex}
          >
            <div className={classes.titleBlock}>
              <div className={classes.titleText}>{ReactHtmlParser(title)}</div>
              {subtitle ? (
                <Typography
                  component="div"
                  variant="caption"
                  className={classes.subtitleText}
                >
                  {subtitle}
                </Typography>
              ) : null}
            </div>
          </Typography>
          {((isAuthorized(search) || isAuthorized(boards) || isAuthorized(projects)) && ENABLE_ZIP_DOWNLOADS) && (
            <Tooltip title="Download Manager">
              <Button
                onClick={() =>
                  toggleRightSidenav(
                    DOWNLOAD_MANAGER,
                    isToggleRightSidenav &&
                    rightSideNavComponent !== DOWNLOAD_MANAGER,
                  )
                }
                className={
                  isToggleRightSidenav && rightSideNavComponent === DOWNLOAD_MANAGER
                    ? classes.uploadManagerActive
                    : classes.uploadManager
                }
              >
                <DownloadingOutlined className={classes.headerIcon} />
              </Button>
            </Tooltip>
          )}

          {isAuthorized(projects) && (
            <Tooltip title="Toggle Upload Manager">
              <Button
                onClick={toggleUploadManager}
                className={
                  showUploadManager
                    ? classes.uploadManagerActive
                    : classes.uploadManager
                }
              >
                <BackupIcon className={classes.headerIcon} />
              </Button>
            </Tooltip>
          )}

          {isAuthorized(boards) && (
            <Tooltip title="Toggle Boards Dialog">
              <Button
                onClick={() =>
                  toggleRightSidenav(
                    BOARDS_TITLE,
                    isToggleRightSidenav &&
                    rightSideNavComponent !== BOARDS_TITLE,
                  )
                }
                className={
                  isToggleRightSidenav && rightSideNavComponent === BOARDS_TITLE
                    ? classes.uploadManagerActive
                    : classes.uploadManager
                }
              >
                <ViewAgenda className={classes.headerIcon} />
              </Button>
            </Tooltip>
          )}

          {showFeedBack && (
            <Tooltip title="Need Help?">
              <Button onClick={addFeedback}>
                <HelpIcon className={classes.headerIcon} />
              </Button>
            </Tooltip>
          )}

          <Divider className={classes.divider} />
          <Dropdown user={displayName} company={company} />
        </Toolbar>
      </AppBar>

      {isModalOpen && <Feedback onClose={onClose} modalOpen={isModalOpen} env={env} />}
    </div>
  )
}

const mapStateToProps = (state, ownProps = {}) => ({
  uploads: state.uploads,
  user: {
    email: selectUserEmail()(state),
    isAuthorized: selectIsAuthorized()(state),
    noAccessModalShown: state.auth?.noAccessModalShown,
    lanId: selectUserId()(state),
    company: selectUserCompany()(state),
    memberOf: selectMemberOf()(state),
    displayName: state.auth?.displayName,
  },
  title: state.layout?.headerTitle || ownProps.title,
  subtitle: selectHeaderSubtitle()(state) || ownProps.subtitle,
  role: state.headerReducer?.role,
  isToggleRightSidenav: selectIsToggleRightSidenav()(state),
  rightSideNavComponent: selectRightSideNavComponent()(state),
})

export default connect(mapStateToProps, {
  toggleUploadManager,
  toggleRightSidenav,
})(withAuth()(withEnv()(withRouter(Header))))
